import { DndContext, PointerSensor, KeyboardSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, useSortable, verticalListSortingStrategy, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

function Row({ id, children, testId }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  return (
    <li ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition }} className={`relative ${isDragging ? "z-10 opacity-80" : ""}`} data-testid={testId}>
      <div className="flex items-stretch">
        <button className="px-1 text-slate-300 hover:text-slate-500 cursor-grab active:cursor-grabbing touch-none" aria-label="Trascina per riordinare" {...attributes} {...listeners}>
          <GripVertical size={14} />
        </button>
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </li>
  );
}

export default function SortableList({ items, onMove, render, testIdPrefix }) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 4 } }), useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }));
  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    onMove(items.findIndex((x) => x.id === active.id), items.findIndex((x) => x.id === over.id));
  };
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={items.map((x) => x.id)} strategy={verticalListSortingStrategy}>
        <ul className="space-y-0.5">
          {items.map((it, i) => <Row key={it.id} id={it.id} testId={`${testIdPrefix}-${i}`}>{render(it, i)}</Row>)}
        </ul>
      </SortableContext>
    </DndContext>
  );
}
